{
  "nl": {
    "mainFobizzNavbar": {
      "a11y": {
        "actions": "Acties",
        "closeNavigation": "Navigatie sluiten",
        "mainNav": "Hoofdnavigatie",
        "openNavigation": "Navigatie openen",
        "skipToContent": "Naar inhoud",
        "closeFlyout": "Flyout sluiten"
      },
      "login": "Inloggen",
      "logoHint": "Hier ga je terug naar de startpagina",
      "myfobizz": {
        "headers": {
          "adminArea": "Beheeromgeving",
          "myfobizz": "Mijn fobizz"
        },
        "links": {
          "backofficePlatform": "Backoffice",
          "contact": "Hulp en Contact",
          "folders": "Mijn Inhoud",
          "histories": "Mijn Geschiedenis",
          "news": "Nieuws",
          "partnersOverview": "Overzicht Partners",
          "profile": "Mijn Profiel",
          "features": "Feature Flags",
          "reviewerSection": "Reviewer Sectie",
          "subscriptions": "Mijn Abonnementen",
          "timetable": "Lesrooster",
          "toTeach": "Naar to teach"
        }
      },
      "navbarSearch": {
        "placeholder": "Snelle toegang",
        "results": {
          "courses": "Cursussen",
          "empty": "Geen resultaten",
          "materials": "Lesmateriaal",
          "myContent": "Mijn Inhoud",
          "schoolClassesAndProjects": "Klassenruimtes en Projecten",
          "showAll": "Alles tonen",
          "showAllSchoolClasses": "Naar de klassenruimtes",
          "showAllTools": "Naar de Tools",
          "showAllWithCount": "Alle {count} tonen",
          "tools": "Tools"
        }
      },
      "breadcrumb": {
        "tools": "Tools"
      },
      "pupilLogin": {
        "text": "Werk met AI-ondersteuning en lesmateriaal. Je krijgt je persoonlijke toegang van je docent.",
        "title": "Inloggen als leerling"
      },
      "signup": {
        "text": "Maak een gratis account aan en krijg beperkte toegang tot cursussen, tools en lesmateriaal.",
        "title": "Registreren"
      },
      "teacherLogin": {
        "text": "Maak en beheer lesmateriaal voor je klas en zet AI in voor je projecten.",
        "title": "Inloggen als docent"
      },
      "tooltips": {
        "homepage": "Naar startpagina",
        "myfobizz": "Mijn fobizz",
        "search": "Snelle toegang tot alle cursussen en lesmateriaal"
      },
      "coachmarkTour": {
        "title": "Nieuwe navigatie",
        "next": "Verder",
        "done": "Klaar",
        "steps": {
          "step1": "Met de nieuwe navigatie bereik je de belangrijkste gebieden en functies nu nog sneller.",
          "step2": "Onder Organiseren vind je je Inhoud, Klassenruimtes en Lesroosters centraal op één plek.",
          "step3": "Via je avatar houd je je licentiestatus in de gaten en kom je bij andere belangrijke informatie."
        }
      },
      "sharedLibraryHint": {
        "title": "NIEUW: Gedeelde Inhoud",
        "headline": "Materiaal samen delen",
        "body": "Maak kopieën uit je Inhoud naar de Gedeelde Inhoud of maak daar direct inhoud aan.",
        "confirm": "Ok"
      },
      "licenseInfo": {
        "summary": "{type}: {areas}",
        "types": {
          "einzel": "Individuele licentie",
          "schul": "Schoollicentie"
        },
        "areas": {
          "courses": "Cursussen",
          "tools": "Tools",
          "toTeach": "to teach"
        },
        "limited": "Beperkt gebruik (Upgrade)"
      },
      "offcanvas": {
        "headers": {
          "organize": "Organiseren",
          "mySchool": "Mijn School",
          "settings": "Instellingen",
          "partners": "Partners"
        },
        "links": {
          "sharedLibrary": "Gedeelde Inhoud",
          "classes": "Klassenruimtes",
          "schoolOverview": "Overzicht",
          "licenseManagement": "Licentiebeheer",
          "internalWorkshops": "Interne Workshops",
          "authorArea": "Auteursomgeving"
        }
      },
      "tabs": {
        "start": "Start",
        "organize": "Organiseren",
        "tools": "Tools",
        "material": "Materiaal",
        "partner": "Partners",
        "courses": "Cursussen"
      },
      "flyout": {
        "organize": {
          "folders": {
            "headline": "Mijn Inhoud",
            "description": "Je materialen op één plek",
            "linkLabel": "Naar opslag"
          },
          "sharedLibrary": {
            "headline": "Gedeelde Inhoud",
            "description": "Materiaal delen met je schoolgroep",
            "linkLabel": "Naar opslag"
          },
          "classes": {
            "headline": "Klassenruimtes",
            "description": "Klassen aanmaken en met leerlingen werken",
            "linkLabel": "Klassenruimte aanmaken",
            "linkLabelPopulated": "Alles tonen"
          },
          "timetable": {
            "headline": "Lesrooster",
            "description": "Lessen plannen en materiaal koppelen",
            "linkLabel": "Lesrooster aanmaken",
            "linkLabelPopulated": "Tonen",
            "todayTime": "vandaag, {time}"
          }
        },
        "material": {
          "partner": {
            "headline": "fobizz & Partners",
            "description": "Materialen van fobizz en partners",
            "linkLabel": "Materiaal ontdekken"
          },
          "toTeach": {
            "headline": "Inhoud",
            "description": "Materialen van to teach",
            "linkLabel": "Materiaal ontdekken"
          },
          "community": {
            "headline": "fobizz Community",
            "description": "Materialen van de fobizz Community",
            "linkLabel": "Materiaal ontdekken"
          },
          "bookmarks": {
            "headline": "Bladwijzerlijst",
            "description": "Opgeslagen materialen",
            "linkLabel": "Naar bladwijzerlijst"
          }
        },
        "tools": {
          "aiChat": {
            "headline": "AI-Chat en Assistenten",
            "items": {
              "chat": "AI-Chat",
              "assistants": "Assistentencatalogus",
              "miniTool": "Promptlab"
            }
          },
          "multimedia": {
            "headline": "AI Multimedia Tools",
            "items": {
              "image": "Afbeelding genereren",
              "podcast": "Podcast",
              "transcript": "Transcriptie"
            }
          },
          "material": {
            "headline": "Materiaal aanmaken",
            "items": {
              "worksheet": "Werkblad",
              "classroomScreen": "Digitale Tafel",
              "survey": "Enquête"
            }
          },
          "share": {
            "headline": "Inhoud delen",
            "items": {
              "fileSharing": "Bestanden Delen",
              "qrCode": "QR-Code",
              "linkShortener": "Link verkorten"
            }
          },
          "showAll": "Alles tonen",
          "showAllTools": "Alle tools tonen"
        },
        "start": {
          "stats": {
            "fortbildungen": "Nascholing | Nascholingen",
            "materialien": "Materiaal | Materialen",
            "klassen": "Klas | Klassen",
            "prompts": "Prompt | Prompts"
          }
        },
        "courses": {
          "catalog": {
            "headline": "Cursuscatalogus",
            "liveWebinare": "Live-webinars",
            "fortbildungen": "Cursussen",
            "linkLabel": "Naar de cursuscatalogus"
          },
          "myCourses": {
            "headline": "Mijn Cursussen",
            "descriptionEmpty": "Je hebt geen actieve cursussen of extra kwalificaties",
            "activeCount": "Actieve cursussen ({count})",
            "bookmarkedCount": "Opgeslagen cursussen ({count})",
            "linkLabel": "Naar mijn cursussen",
            "linkLabelEmpty": "Cursussen ontdekken"
          },
          "additionalQualifications": {
            "headline": "Extra kwalificaties",
            "description": "Schrijf je nu in voor de nieuwe ZQ's in het schooljaar 2026/2027",
            "linkLabel": "Naar de infopagina"
          },
          "aiLiteracyTraining": {
            "headline": "AI Literacy Training",
            "description": "Doe mee met onze gratis online training over AI-geletterdheid voor leerkrachten.",
            "linkLabel": "Meer informatie & aanmelden"
          }
        }
      },
      "mobileNav": {
        "tools": {
          "showAll": "Alle tools tonen"
        }
      },
      "startPage": {
        "greeting": "Hallo {user}!",
        "greetingFallback": "Hallo!",
        "subtitle": "Welkom bij fobizz.",
        "welcomeBack": "Welkom terug.",
        "news": {
          "headline": "Nieuws",
          "linkLabel": "Al het nieuws tonen"
        },
        "toTeach": {
          "label": "Materiaal | Materialen",
          "linkLabel": "to teach: {count} materiaal, openen in nieuw tabblad | to teach: {count} materialen, openen in nieuw tabblad"
        }
      }
    }
  }
}
